var gatingRules = {
  "KG_BOY": require("./content/gating_rules/BOYKG"),
  "01_BOY": require("./content/gating_rules/BOY01"),
  "KG_MOY": require("./content/gating_rules/MOYKG"),
  "01_MOY": require("./content/gating_rules/MOY01"),
  "KG_EOY": require("./content/gating_rules/EOYKG"),
  "01_EOY": require("./content/gating_rules/EOY01")
};
var compositeScoreCutscores = require('./content/composite_score/composite_score_cutscores');
module.exports = {
  compositeScoreCutscores: compositeScoreCutscores,
  gatingRules: gatingRules
};